<template>
  <div class="page-container md-layout-column">
    <md-toolbar class="md-transparent md-title" md-elevation="0">
      <div class="md-toolbar-section-start">
        <span>Treatment types</span>
      </div>

      <div class="md-toolbar-section-end">
        <md-button
          style="float: right"
          class="md-icon-button"
          @click="closeWindow"
        >
          <md-icon>close</md-icon>
        </md-button>
      </div>
    </md-toolbar>
    <md-progress-bar
      md-mode="query"
      v-if="menuData == null && menuData.length == 0"
    ></md-progress-bar>

    <md-empty-state
      v-if="noMenuDataLoaded"
      class="md-secondary md-small"
      md-icon="hourglass_top"
      md-label="No treatment categories found."
      md-description="Please try again later. Ask your admin to configure booking system."
    >
    </md-empty-state>

    <md-list>
      <md-list-item
        v-for="(item, index) in menuData"
        :key="item.cat"
        @click="selectCat(item, index)"
        :to="'/category/' + index"
      >
        <span class="md-list-item-text">{{ item.cat }}</span>
      </md-list-item>
    </md-list>
  </div>
</template>

<script>
import { eventBus } from "../../eventbus";

export default {
  name: "CategoriesUserDrawer",
  data: function () {
    return {
      noMenuDataLoaded: false,
    };
  },
  computed: {
    menuData() {
      return this.$store.state.menuData;
    },
  },
  methods: {
    selectCat: function (cat, index) {
      console.log("cat", cat, index);
      eventBus.selectedCategory(cat, index);
      eventBus.updateDialogTitle(cat.cat);
      eventBus.selectedDateTime(null, null);
      eventBus.openCloseLeftSidemenu(false);
    },
    closeWindow: function () {
      eventBus.openCloseLeftSidemenu(false);
    },
  },
  created: async function () {
    var self = this;
    eventBus.$on("menu-data-changed", function (itemKey) {
      console.log(
        "self.$store.state.menuData[itemKey]",
        self.$store.state.menuData[itemKey]
      );

      if (
        parseInt(itemKey) >= 0 &&
        self.$store.state.menuData.length > parseInt(itemKey)
      ) {
        self.selectCat(self.$store.state.menuData[itemKey]);
        console.log(
          "self.$store.state.menuData[itemKey]",
          self.$store.state.menuData[itemKey]
        );
      }
    });
  },
  mounted: function () {
    var self = this;
    setTimeout(function () {
      if (self.$store.state.menuData.length == 0) {
        self.noMenuDataLoaded = true;
      }
    }, 3000);
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  min-height: 300px;
  overflow: hidden;
  position: relative;
  border: 1px solid rgba(#000, 0.12);
}

.md-drawer {
  width: 230px;
  max-width: calc(100vw - 125px);
}
</style>